export const ILH_PORTALS = {
  AGENT: "MOD201",
  MEMBER: "MOD202",
  BENEFICIARY: "MOD203",
  GROUP: "MOD204"
};
